import { useLayoutEffect, useRef } from 'react'
import type { PendingCtrlWheelAnchor } from '../types/pending-ctrl-wheel-anchor'

/**
 * Zoom scroll-anchor state: the pointer anchor a ctrl+wheel / pinch zoom leaves for the next zoom
 * layout pass (`use-zoom-scroll-anchor`), and the last explicit zoom. Both reset on a spread switch.
 */
export function useZoomScrollAnchorRefs({ checkpointLoadKey }: { checkpointLoadKey?: string }) {
  /** When set, the next zoom layout pass should anchor scroll to the pointer instead of ruler (0,0). */
  const pendingCtrlWheelAnchorRef = useRef<PendingCtrlWheelAnchor | null>(null)

  /** Last explicit zoom (non-fit) for scroll correction while zooming. */
  const prevExplicitZoomAnchorRef = useRef<number | null>(null)

  useLayoutEffect(() => {
    prevExplicitZoomAnchorRef.current = null
    pendingCtrlWheelAnchorRef.current = null
  }, [checkpointLoadKey])

  return { pendingCtrlWheelAnchorRef, prevExplicitZoomAnchorRef }
}
